@import '../../styles/palette.scss';
@import '../../styles/fonts.scss';
@import './mixins.scss';

$text-field-btn-bottom: 0.45rem;

.dropdown {
  min-width: 5rem;
  position: relative;
  vertical-align: center;
  width: 100%;
}

.disabled {
  pointer-events: none !important;
}

.input {
  pointer-events: none;
  position: relative;
  width: 100%;

  .textInputContainer {
    @include barlow(16);
    display: inline-grid;
    pointer-events: auto;
    width: 100%;

    .noLabel {
      margin-top: 0;
    }

    .hasLabel {
      margin-top: 0.3125rem;
    }

    input {
      padding-left: $padding + 0.25rem;
      padding-right: $padding + 1rem;
    }

    .textInputLabel {
      color: _palette(text-primary);
      margin-top: 0.125rem;

      &:hover {
        & > label {
          color: _palette(secondary);
        }

        & > input {
          border: $border-width-thick solid _palette(secondary);
          padding-left: $padding-large-border + 0.25rem;
          padding-right: $padding-large-border + 1rem;
        }
      }

      .required {
        color: _palette(text-red);
        font-weight: 600;
      }
    }

    .fakeHoverLabel {
      color: _palette(secondary);
    }

    .fakeHoverBorder {
      border: $border-width-thick solid _palette(secondary);
    }

    .textInputBorder {
      border: $border-width solid _palette(black-25);
    }

    .hideBorder:not(:hover):not(:focus):not(.fakeHoverBorder):not(.clicked) {
      border: $border-width-thick solid transparent;
    }

    .hideBackground {
      background: transparent !important;
    }

    .textInput {
      background-color: _palette(bg-secondary);
      border-radius: 5px;
      cursor: pointer;
      font-size: 1rem;
      outline: none;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      width: 100%;
      height: $inputHeight;

      &:hover {
        border-color: _palette(secondary);
        border-width: $border-width-thick;
      }

      &:focus,
      &:focus:hover {
        border-color: _palette(secondary);
        border-width: $border-width-thick;
      }

      &:disabled {
        background-color: _palette(text-secondary);
      }
    }

    .textInput.highlightPlaceholder {
      &::-webkit-input-placeholder {
        color: _palette(secondary);
      }

      &:-ms-input-placeholder {
        color: _palette(secondary);
      }

      &::placeholder {
        color: _palette(secondary);
      }
    }

    .textInput.alert:not(.clicked) {
      border-color: _palette(text-red) !important;
      text-shadow: 0 0 0 _palette(text-red) !important;

      &::-webkit-input-placeholder {
        color: _palette(text-red) !important;
      }

      &:-ms-input-placeholder {
        color: _palette(text-red) !important;
      }

      &::placeholder {
        color: _palette(text-red) !important;
      }

      &:hover,
      &:focus,
      &.fakeHoverBorder {
        border-color: _palette(warning-1) !important;
      }
    }

    .textInput.clicked {
      border-color: _palette(secondary) _palette(secondary) _palette(black-25)
        _palette(secondary);
      border-radius: 5px 5px 0 0;
      box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.5);
      color: _palette(links);
      outline: none;

      &:focus,
      &:focus:hover {
        border-color: _palette(secondary) _palette(secondary) _palette(black-25)
          _palette(secondary);
        border-radius: 5px 5px 0 0;
      }
    }
  }

  .arrow {
    bottom: $text-field-btn-bottom;
    height: 1.5rem;
    pointer-events: auto;
    position: absolute;
    right: 0.5rem;
    width: 1.5rem;

    .arrowSvg {
      border-radius: 50%;
      transition: all 0.25s;
    }

    &:focus {
      outline: none;

      .arrowSvg {
        background-color: _palette(bg-primary-dark);
        fill: _palette(secondary);
      }
    }

    &:hover {
      cursor: pointer;

      .arrowSvg {
        background-color: _palette(bg-primary-dark);
        fill: _palette(secondary);
      }
    }
  }

  svg {
    fill: _palette(text-primary);
  }
}

.dropdownBorder {
  border: $border-width-thick solid _palette(secondary);
  border-radius: 0 0 5px 5px;
  border-top: 0;
}

.dropdownmenu {
  box-shadow: 0 3px 4px 0 rgba(0, 0, 0, 0.5);
  height: auto;
  left: 0;
  margin-bottom: $border-width;
  max-height: 30vh;
  min-width: inherit;
  position: absolute;
  right: 0;
  z-index: 1300;
  overflow-y: auto;

  .dropdownButtonContainer {
    align-items: center;
    background-color: _palette(bg-secondary);
    display: flex;
    justify-content: center;
    outline: none;
    padding: 0.5rem 0.5rem 0.5rem 0;

    .button {
      min-width: 1.875rem;
      width: 75%;
    }
  }

  .dropdownitem {
    @include barlow(16);
    background-color: _palette(bg-secondary);
    color: _palette(text-primary);
    height: 2.25rem;
    padding: 0.5rem;
    display: flex;

    .helpButton {
      position: relative;
      right: -2%;
      min-width: 10%;
      height: 1.5rem;
    }

    .dropdownItemText {
      position: relative;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      width: 90%;
    }

    & > * {
      vertical-align: middle;
    }

    &,
    & > * {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    &:hover {
      cursor: pointer;
    }

    &:focus {
      outline: none;
    }

    &:hover,
    &:focus {
      &:not(.disabledItem) {
        background-color: #f2faff;
      }

      .checkbox {
        * {
          color: _palette(secondary-dark);
        }
      }

      .checkboxOutline {
        * {
          color: _palette(secondary-dark);
        }
      }
    }

    %checkboxCommon {
      margin-right: 0.5rem;
      padding: 0.1rem;
    }

    .checkbox {
      @extend %checkboxCommon;

      * {
        color: _palette(secondary);
      }

      &:hover,
      &:focus {
        * {
          color: _palette(secondary-dark);
        }
      }
    }

    .checkboxDisabled {
      @extend %checkboxCommon;
    }

    .checkboxOutline {
      @extend %checkboxCommon;

      &:hover,
      &:focus {
        * {
          color: _palette(secondary);
        }
      }
    }

    &.alert {
      background-color: _palette(table-row-alert);
    }

    &.disabledItem {
      color: _palette(text-secondary);

      &:hover,
      &:focus {
        cursor: default;
      }
    }
  }
}
